export default __webpack_public_path__ + "1.17.16/static/media/LibreDataShare_SimplifiedChinese.2e517bfd.svg";